export default __webpack_public_path__ + "static/media/icon.81145076.less";